import { IFlexClasses } from "../layout/flex";

export default <IFlexClasses>{
  base: "box-border w-full flex items-center justify-between",
};
